import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxEmptyFn = /* @__PURE__ */ createRecipe('combobox-empty', {}, [])

const comboboxEmptyVariantMap = {}

const comboboxEmptyVariantKeys = Object.keys(comboboxEmptyVariantMap)

export const comboboxEmpty = /* @__PURE__ */ Object.assign(memo(comboboxEmptyFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxEmpty',
  __getCompoundVariantCss__: comboboxEmptyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxEmptyVariantKeys,
  variantMap: comboboxEmptyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxEmptyVariantKeys)
  },
  getVariantProps: comboboxEmptyFn.getVariantProps,
})